<template>
  <div class="langfooter">
    <div class="footer-miscs">
      <span>暗能软件，版权所有</span>
      <img src="@/assets/ghs.png" class="ghs" />
      <a target="_blank" href='http://www.beian.miit.gov.cn'>陕ICP备17013436</a>
    </div>
    <div class="namespace" style="color:#fff;">copyright ©️2020 xingmingtupu.com All rights reserved</div>
  </div>
</template>

<script>
export default {};
</script>

<style scoped lang="scss">
.langfooter {
  width: 100%;
  text-align: center;
  position: absolute;
  z-index: 100;
  bottom: 20;
  padding: 20px 10px;
  box-shadow: 0 0 2px #888;
  background-color: #267162;
  .namespace {
      @media screen and(max-width:1200px) {
        font-size: 12px;
      }
    }
  .footer-miscs {
    display: flex;
     @media screen and(max-width:1200px) {
        font-size: 12px;
      }
    color: #fff;
    align-items: center;
    justify-content: center;
  }
}
</style>
